<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Success Stories"
                   :links="[{title:'Home', url:'/'},{title:'Success Stories'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="5"></sidebar>
        </section>
        <section class="content">
          <div class="heading-black1">Success Stories</div>
          <success-story v-for="(stories,index) in stories" :key="index" :stories="stories"></success-story>
        </section>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>

<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/alumni/Sidebar";
import KeyRecruiters from "@/components/KeyRecruiters";
import SuccessStory from "@/components/SuccessStory";

export default {
  name: "SuccessStories",
  components: {
    KeyRecruiters,
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent, SuccessStory


  },
  data() {
    return {
      stories: [
        {
          img: 'puja_thorat',
          name: 'Mrs. Puja Thorat',
          position: 'Owner: Indira pre-school, (IPS) Nasik.',
          details: 'My college days are unforgettable and in fact those days are the most happiest and fruitful days in my life. I proudly feel that I cherished every moments of my college. I got infinite love and lessons from my teachers they made me do "work hard" for the way to success. I Will always be thankful to my college and my teachers. Due to motivation and guidelines from my teachers to inspire me to achieve my goals and right now i am the owner of pre-school at Nasik.'
        },
        {
          img: 'puja_lipte',
          name: 'Miss. Puja Lipte',
          position: 'Team Leader, Wise Owl Investment & Insurance Pvt. Ltd. Nashik',
          details: 'I feel so lucky to be alumni of SND College of Engineering & Research Center. I am so glad to have such an inspiring, intelligent & motivating teachers who not only taught me the lesson of engineering but also the lesson of life. I feel so proud to say that whatever I am today is only because of their endless.'
        },
        {
          img: 'sagar_gadoje',
          name: 'Mr. Sagar Ghadoje',
          position: 'Sr. Officer (Maintenance) , Kalyani Technoforge Ltd, Pune.',
          details: '"My journey at SND college has been turning point in my life as this prestigious institution is helping me grow in various aspects. SND college has also provided me numerous platforms to showcase my talent. I am very thankful to the faculty for being so supportive, to help me sharpen.'
        },
        {
          img: 'sagar_weljali',
          name: 'Mr. Sagar Weljali',
          position: 'Sr. Application Engineer Beacon-India Solid Work, Pune.',
          details: 'During Engineering our teachers always told me the importance of theoretical and practical knowledge and also about extracurricular activities. I followed all the instructions of teachers.'
        },
        {
          img: 'swati_sardar',
          name: 'Miss. Swati Sardar',
          position: 'AMVI, Govt. of Maharashtra',
          details: 'Currently I am working in as AMVI in Govt of Maharashtra. As what l feel is we should get good quality of learning which got fulfilled in SND college of Engineering. Great mentoring by staff & senior authorities is done in my college.'
        },
        {
          img: 'vishal_halwai',
          name: 'Mr. Vishal Halwai',
          position: 'Production Engineer, Advik Hi-Tech Pvt.Ltd Pune.',
          details: 'I want to convey my warm regards and been thankful to my college for guiding me to become a successful engineer. The relation between faculty and student is very cordial and they all have in-depth knowledge about their subjects which made my concepts strong & helped me in cracking.'
        },
      ]
    }
  }
}
</script>

<style scoped>

</style>
